export { UserPermissionsResolve } from './user-permissions.resolve';
